<template>
  <div class="w-100">
    <div class="card shadow overflow-hidden border-top-0 rounded-top-0 p-0 mx-0" :class="{ hide: submitted }">
      <form class="w-100" method="post" novalidate="true" @submit.prevent="submitForm">
        <div class="card-body px-4 py-4">
          <div class="form-group row flex-column">
            <label class="col text-gray mb-3 font-PM" for="valor">Ingresá el valor mensual del alquiler</label>
            <div class="col">
              <div class="content-element bg-white border border-borders rounded-lg overflow-hidden">
                <div class="element-form-ico w-100 text-primary d-flex align-items-stretch">
                  <div
                    class="pre bg-light border-right border-borders d-flex justify-content-center align-items-center p-2">
                    <h2 class="font-PM text-nowrap px-2 mb-0">$</h2>
                  </div>
                  <input v-model="form.valor" type="number"
                    class="form-control h-auto form-control-lg border-0 text-primary text-left font-AR" id="valor"
                    name="valor" placeholder="50.000" maxlength="8" required>
                </div>
              </div>
            </div>
          </div>
          <div
            class="form-group row flex-column flex-sm-row no-gutters justify-content-center align-items-center border border-borders rounded p-3">
            <label class="col text-gray pr-0 pr-sm-4 my-2 my-sm-1 font-PM">¿Posee garantía?</label>
            <div class="content-element bg-transparent wrapper-btn-drop-auto p-1 my-2 my-sm-1 ml-n3 ml-sm-0">
              <div class="row no-gutters justify-content-center align-items-center flex-nowrap">
                <div class="order-1">
                  <button :class="{ selected: !form.garantia }" @click="form.garantia = false" type="button"
                    class="btn btn-text btn-sm font-R active-circle-button-left text-gray text-left text-uppercase w-100 px-2 py-0 mb-0">
                    <div class="font-sm-small d-flex text-center text-sm-left">de <br
                        class="d-block d-sm-none">propiedad</div>
                  </button>
                </div>
                <div class="order-3">
                  <button :class="{ selected: form.garantia }" @click="form.garantia = true" type="button"
                    class="btn btn-text btn-sm font-R active-circle-button-right text-gray text-left text-uppercase w-100 px-2 py-0 mb-0">
                    <div class="font-sm-small text-center text-sm-left">de <br class="d-block d-sm-none">caución</div>
                  </button>
                </div>
                <div class="btn-drop btn btn-left rounded-pill bg-light border border-borders order-2 py-0"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer bg-transparent border-0 px-4 pt-2 pt-md-4 pb-0">
          <div class="row justify-content-center align-items-center">
            <div class="col-md-12">
              <div class="row no-gutters justify-content-end">
                <button type="submit"
                  class="btn btn-outline-primary rounded-pill cta-start mb-4 text-uppercase font-ARB btn-square">Ver
                  resultado</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <!-- resultado -->
    <div class="col-lg-12 mb-4 mb-xl-5 resultados">
      <div v-if="submitted">
        <div class="row">
          <div class="col-md-12 card rounded-top-0 border-top-0 shadow overflow-hidden mx-0 py-3 mb-4">
            <div class="row no-gutters justify-content-center align-items-center bg-primary rounded py-5">
              <div class="col-md-9 text-center py-xl-5">
                <img src="/images/icons/percentage.svg" class="mb-4" alt="resultado">
                <div class="result">
                  <div class="element-form-ico w-100 d-flex justify-content-center align-items-center text-white">
                    <h2 class="font-PB text-nowrap text-center mb-3">$ <span id="cont-resultado">{{ formatNumber(total)
                        }}</span></h2>
                  </div>
                </div>
                <div>
                  <button @click="resetForm"
                    class="btn btn-secondary rounded-pill text-uppercase font-ARB btn-square">Volver a calcular</button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <p class="small font-R text-gray"><b>Aclaración:</b> El cálculo es estimativo y contempla aportes
              notariales, inscripción del título, certificados, estudios de títulos entre otros gastos fijos. No están
              considerados los honorarios del escribano que paga el comprador y rondan el 2% del valor en el que se
              escritura-. En el caso del vendedor: si es persona física y reemplaza vivienda, para obtener la exención
              del ITI (1,5%) debe tramitar el certificado de no retención. La calculadora considera sólo las escrituras
              que se realizan en la Capital Federal y entre personas humanas – no jurídicas –. En la Provincia de Buenos
              Aires, por ejemplo, el impuesto a los sellos es menor y además hay gastos de agrimensura que paga el
              vendedor de la propiedad, entre otras diferencias.</p>
          </div>
        </div>
      </div>
    </div>
    <!-- fin resultado -->
  </div>
</template>


<script>
import { ref, reactive } from 'vue';

export default {
  setup() {
    const form = reactive({
      valor: null,
      garantia: false,
    });

    const submitted = ref(false);
    const total = ref(0);

    const submitForm = () => {
      if (form.valor) {
        submitted.value = true;
        let totalValue = parseFloat(form.valor);
        let deposito = totalValue;
        let garantia = !form.garantia ? 800 : totalValue;

        total.value = totalValue + deposito + garantia;
      }
    };

    const resetForm = () => {
      submitted.value = false;
      form.valor = null;
      form.garantia = false;
      total.value = 0;
    };

    const formatNumber = (value) => {
      if (isNaN(value)) return value;

      return new Intl.NumberFormat('es-ES', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    };

    return {
      form,
      submitted,
      total,
      submitForm,
      resetForm,
      formatNumber,
    };
  }
};
</script>


<style lang="scss">
a {
  cursor: pointer;
}
</style>
